import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, MenuItem, Typography, Alert } from '@mui/material';
import studioApi from '../../api/studioApi';
import userApi from '../../api/userApi';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

export default function StudioCreatePage() {
  const [params] = useSearchParams();
  const userId = params.get('userId');
  const [form, setForm] = useState({ ragioneSociale: '', codiceFiscale: '', partitaIVA: '', email: '', utenteId: '' });
  const [users, setUsers] = useState([]);
  const [err, setErr] = useState(null);
  const navigate = useNavigate();

useEffect(() => {
  userApi.list({ profile: 'STUDIO' }).then(r => {
    setUsers(r.data.content || []);
    if (userId) {
      setForm(f => ({ ...f, utenteId: userId }));
    }
  });
}, [userId]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await studioApi.create(form);
      navigate('/studi');
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  return (
    <Container>
      <Typography variant="h5">Crea Studio</Typography>
      {err && <Alert severity="error">{String(err)}</Alert>}
      <form onSubmit={submit}>
        <TextField fullWidth sx={{ my: 1 }} label="Ragione Sociale" value={form.ragioneSociale} onChange={e => setForm({...form, ragioneSociale: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Codice Fiscale" value={form.codiceFiscale} onChange={e => setForm({...form, codiceFiscale: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Partita IVA" value={form.partitaIVA} onChange={e => setForm({...form, partitaIVA: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
        <TextField
          select
          fullWidth
          label="Utente"
          value={form.utenteId}
          disabled={!!userId}
          onChange={e => setForm({ ...form, utenteId: e.target.value })}
        >
          {users.map(u => <MenuItem key={u.id} value={u.id}>{u.username}</MenuItem>)}
        </TextField>
        <Button variant="contained" type="submit">Crea</Button>
      </form>
    </Container>
  );
}